import AlertDialog from "@/shared/ui/AlertDialog";
import useFeedbackStore from "@/shared/model/feedbackStore";
import { cautionIcon } from "@/shared/ui/alertDialogIcons";

/**
 * 전역 AlertDialog 호스트 — feedbackStore.alertDialog 슬라이스를 구독해 AlertDialog 를 구동.
 * - native back: AlertDialog 공통 규칙(배경 탭과 같게, B2 결정 2026-10-27) — closeOnBackdrop=false 면 흔들림,
 *   true 면 onDismiss(닫기만). 뒤로가기로 onConfirm 이 실행되지 않으며, 팝업 아래 화면으로 새지 않는다.
 * - onDismiss=closeAlertDialog: backdrop dismiss 시 onConfirm 콜백 발동 없이 닫기만
 * - icon 기본값: 호출처가 icon 을 지정하지 않으면(undefined) ⚠️ cautionIcon 을 기본으로 부여.
 *   `=== undefined` 분기 — AlertDialog 는 `icon != null` 로 아이콘 영역을 그리므로 명시적 `icon: null`
 *   ("아이콘 의도적 생략")은 보존한다. (nullish 병합 `??` 은 null 까지 덮으므로 사용 금지.)
 */
const AlertDialogHost = () => {
  const alertDialog = useFeedbackStore((s) => s.alertDialog);
  const closeAlertDialog = useFeedbackStore((s) => s.closeAlertDialog);

  return (
    <AlertDialog
      isOpen={alertDialog.isOpen}
      icon={alertDialog.icon === undefined ? cautionIcon : alertDialog.icon}
      title={alertDialog.title ?? ""}
      message={alertDialog.message ?? ""}
      detail={alertDialog.detail}
      confirmLabel={alertDialog.confirmLabel}
      closeOnBackdrop={alertDialog.closeOnBackdrop}
      onConfirm={() => {
        alertDialog.onConfirm?.();
        closeAlertDialog();
      }}
      onDismiss={closeAlertDialog}
    />
  );
};

export default AlertDialogHost;
